import axiosInstance from "../instance/AxiosInstance";
export const bookingViewEffect = async (bookingId) => {
  try {
    const response = await axiosInstance.get(
      `/bookservice/getbookingservice?booking_id=${bookingId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Booking";
  }
};
export const bookingViewAllEffect = async (payload) => {
  const params = {
    type: payload.type,
    booked_type: payload.booked_type,
    currentDate: payload.currentDate,
  };

  // Add date filters if provided
  if (payload.from_date) {
    params.from_date = payload.from_date;
  }
  if (payload.to_date) {
    params.to_date = payload.to_date;
  }

  if (payload.search) {
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
    params.search = payload.search;

    if (payload.search_by && payload.search_by.trim() !== "") {
      params.search_by = payload.search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
  }

  try {
    const response = await axiosInstance.get(`/bookservice/list`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Bookings";
  }
};

// UPDATED: fetchAllBookingEffect with date filter support
export const fetchAllBookingEffect = async (payload) => {
  const params = {};

  // Add date filters if provided
  if (payload.from_date) {
    params.from_date = payload.from_date;
  }
  if (payload.to_date) {
    params.to_date = payload.to_date;
  }

  if (payload.search) {
    params.pagination_required = true;
    params.pageSize = payload.pagesize;
    params.pageNo = payload.pageNo;
    params.search = payload.search;

    if (payload.search_by && payload.search_by.trim() !== "") {
      params.search_by = payload.search_by;
    }
  } else {
    params.pagination_required = true;
    params.pageSize = payload.pagesize;
    params.pageNo = payload.pageNo;
  }

  try {
    const response = await axiosInstance.get(
      "/bookservice/servicebookingalldata",
      { params }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch All Bookings";
  }
};

export const fetchAllBookingsEffect = async (booked_type, type = "all") => {
  try {
    const response = await axiosInstance.get(
      `/bookservice/list?pagination_required=false`,
      {
        params: {
          booked_type: booked_type,
          type: type,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch All Bookings";
  }
};

export const fetchCustomerBookingsEffect = async (
  customer_id,
  pageNo,
  pagesize,
  type,
  currentDate,
  vendor_id,
  booked_type,
  search,
  search_by,
  from_date = null,  // ADD DATE PARAMETERS
  to_date = null     // ADD DATE PARAMETERS
) => {
  const params = {
    customer_id: customer_id,
    type,
    vendor_id,
    currentDate,
    booked_type,
    search,
    search_by,
  };

  // Add date filters if provided
  if (from_date) {
    params.from_date = from_date;
  }
  if (to_date) {
    params.to_date = to_date;
  }

  if (search) {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
    params.search = search;

    if (search_by && search_by.trim() !== "") {
      params.search_by = search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
  }

  try {
    const response = await axiosInstance.get(
      `/bookservice/bookinggetbycustomer`,
      { params }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch customer bookings";
  }
};
export const instantBookingAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/bookservice/instantbookservice`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Add Booking";
  }
};
// Edit instant booking
export const bookingEditEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/bookservice/updatebooking/${payload?.bookingId}`,
      payload?.updatedData
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.errorFields || "Failed to Add Booking";
  }
};
export const instantBookingTokenEffect = async () => {
  try {
    const response = await axiosInstance.post(`/auth/ultrainstantToken`);
    return response?.data;
  } catch (error) {
    throw error.response?.data?.errorFields || "Failed to Add Booking";
  }
};

export const bookingDeleteEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/bookservice/cancelbooking/${payload?.payload?.bookingId}`,
      payload?.payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Delete Booking";
  }
};
export const fetchServiceTypeEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/services/getservicetype?service_type=${payload.service_type}&airport_type=${payload.airport_type}&airport_id=${payload.airport_id}`
    );

    return response;
  } catch (error) {
    throw error.response?.data?.message;
  }
};
export const fetchTransitServiceTypeEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/services/gettransitservicetype?transit_type=${payload.transit_type}&service_type=${payload.service_type}&airport_id=${payload.airport_id}`
    );
    return response;
  } catch (error) {
    throw error.response?.data?.message;
  }
};
export const updateBookingDiscountStatusAPI = async (payload) => {
  const response = await axiosInstance.put(
    `/bookservice/bookingserviceapproval/${payload.booking_id}`,
    payload
  );
  return response.data;
};

export const bookingAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/bookservice/bookservice`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Add Booking";
  }
};
export const resendRazorpayLinkAPI = async (payload) => {
  try {
    const response = await axiosInstance.post("/razorpay/resendlink", payload);

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to send";
  }
};

export const updatePaymentStatusEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/bookservice/updatePaymentStatus`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to update payment status";
  }
};


export const updateBookingStatusEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/bookservice/bookingUpdatelogsStatus`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to update Booking status";
  }
};